import React, { useState, useEffect } from 'react';
import moment from 'moment';
import LocalizedMessage from 'react-l10n';
import ReactTableWrapper from '../ReactTableWrapper';
import {
    axiosRequestPayFastPayoutLogs,
    axiosRequestPayoutLogs,
} from '../../actions/user/stripe';
import { __regionCurrencyDisplay, handleAxiosErrors } from '../../_utils';
import Papa from "papaparse";
import ReactLoading from 'react-loading';

function StripePayoutLogs(props) {
    const [payoutList, setPayoutList] = useState([]);
    const [transferList, setTransferList] = useState({});
    const [selectedReference, setSelectedReference] = useState(null);
    const [isLoading, toggleIsLoading] = useState(true);
    const [startingAfter, setStartingAfter] = useState(null);
    const [showMoreLoading, setShowMoreLoading] = useState(false);
    const [showMoreDisabled, setShowMoreDisabled] = useState(false);

    /**
     * Request the stripe payout logs
     *
     * @returns {*}
     */
    const request = async (ref = null, showMore = false) => {
        if (showMore) {
            setShowMoreLoading(true);
        } else {
            toggleIsLoading(true);
        }

        let params = null;

        if (ref !== null) {
            params = {
                PayoutReference: ref,
            };
        }

        if (window.localeCountry != 'South Africa') {
            if (startingAfter) {
                params = params || {}
                params.StartingAfter = startingAfter;
            }
            await axiosRequestPayoutLogs(params)
                .then((response) => {
                    const dataList =
                        response.data.data.readStripeLogs.edges.map(
                            (item) => item.node
                        ) || [];

                    if (dataList.length) {

                        let startingAfter = dataList[dataList.length - 1]?.Reference;
                        if (startingAfter) {
                            setStartingAfter(startingAfter);
                        }
                    }

                    if (dataList.length == 0 || dataList.length < 100) {
                        setShowMoreDisabled(true);
                    }

                    if (ref === null) {
                        setPayoutList([...payoutList, ...dataList]);
                    } else {
                        setTransferList((prevState) => {
                            return {
                                ...prevState,
                                [ref]: dataList,
                            };
                        });
                    }
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                })
                .then(() => {
                    if (showMore) {
                        setShowMoreLoading(false);
                    } else {
                        toggleIsLoading(false);
                    }
                });
        }

        if (window.localeCountry == 'South Africa') {
            await axiosRequestPayFastPayoutLogs()
                .then((response) => {
                    const dataList =
                        response.data.data.readPayFastLogs.edges.map(
                            (item) => item.node
                        ) || [];

                    Papa.parse(dataList[0].response, {
                        header: true,
                        skipEmptyLines: true,
                        complete: function (results) {
                            const rowsArray = [];
                            const valuesArray = [];

                            // Iterating data to get column name and their values
                            results.data.map((d) => {
                                rowsArray.push(Object.keys(d));
                                valuesArray.push(Object.values(d));
                            });

                            if (ref === null) {
                                setPayoutList(valuesArray);
                            } else {
                                setTransferList((prevState) => {
                                    return {
                                        ...prevState,
                                        [ref]: valuesArray,
                                    };
                                });
                            }


                        },
                    });
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                })
                .then(() => {
                    toggleIsLoading(false);
                });
        }
    };

    /**
     * Get the React Table props
     *
     * @returns {{list: {columns: *[], showPagination: boolean}}}
     */
    const getTableProps = () => {
        // const lessThanMD = wWidth < breakpoints.md;
        const tableProps = {
            list: {
                columns: [
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'DATE'} />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            if (selectedReference !== null) {
                                return (
                                    <span className='react-table__info'>
                                        {moment(window.localeCountry == 'South Africa' ? row.original[0] : row.value, 'YYYY-MM-DD').format(
                                            'DD/MM/YYYY'
                                        )}
                                    </span>
                                );
                            }

                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        <a
                                            href='javascript:void(0)'
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setSelectedReference(
                                                    row.original.Reference
                                                );
                                            }}
                                        >
                                            {moment(
                                                window.localeCountry == 'South Africa' ? row.original[0] : row.value,
                                                'YYYY-MM-DD'
                                            ).format('DD/MM/YYYY')}
                                        </a>
                                    </span>
                                </React.Fragment>
                            );
                        },
                        // headerClassName: 'dt-assigned-supplier__name',
                        // className: 'dt-assigned-supplier__name',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'Date',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'TYPE'} />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {window.localeCountry == 'South Africa' ? 'Payout' : row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        // headerClassName: 'dt-assigned-supplier__number',
                        // className: 'dt-assigned-supplier__number',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'Type',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'DESCRIPTION'} />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {window.localeCountry == 'South Africa' ? '' : row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        // headerClassName: 'dt-assigned-supplier__number',
                        // className: 'dt-assigned-supplier__number',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'Description',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'AMOUNT'} />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {__regionCurrencyDisplay(
                                            window.localeCountry == 'South Africa' ? row.original[8] : row.value
                                        )}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        // headerClassName: 'dt-assigned-supplier__number',
                        // className: 'dt-assigned-supplier__number',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'Amount',
                    },
                    {
                        expander: true,
                        Expander: ({ isExpanded, ...rest }) => {
                            return (
                                <React.Fragment>
                                    <button
                                        type='button'
                                        className='react-table__extra-data-toggle'
                                    >
                                        <span className='icon icon-chevron-thick' />
                                    </button>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'hidden',
                        className: 'hidden',
                        width: 45,
                        sortable: false,
                        accessor: 'ID',
                    },
                ],
                showPagination: false,
            },
        };

        return tableProps;
    };

    const HandleShowMore = () => {
        if (!showMoreLoading) {
            request(null, true);
        }
    };

    useEffect(() => {
        request(selectedReference);
    }, [selectedReference]);

    return (
        <React.Fragment>
            {selectedReference !== null && (
                <div className='vspace'>
                    <button
                        className='button-link button-link--back'
                        onClick={(e) => setSelectedReference(null)}
                    >
                        <span>
                            <LocalizedMessage id={'BACK'} />
                        </span>
                    </button>
                </div>
            )}
            <ReactTableWrapper
                loading={isLoading}
                data={
                    selectedReference !== null
                        ? transferList[selectedReference] || []
                        : payoutList
                }
                reactTable={getTableProps()}
                perPage={99999}
            />

            {!isLoading && !selectedReference && !showMoreDisabled &&
                < button
                    className='button'
                    onClick={HandleShowMore}
                    disabled={showMoreDisabled}
                    style={{ position: 'relative' }}
                >

                    <span
                        style={{
                            opacity: showMoreLoading ? 0 : 1,
                        }}
                    >
                        <LocalizedMessage id={'SHOW_MORE'} />
                    </span>
                    {showMoreLoading &&
                        <ReactLoading
                            className='button__spinner'
                            type='spin'
                            color='white'
                            height={20}
                            width={20}
                        />
                    }
                </button>
            }
        </React.Fragment >
    );
}

export default StripePayoutLogs;
